export default __webpack_public_path__ + "static/media/logo.67c0af22.png";